import useLocalStore from '../../../hooks/useLocalStore';
import FJBlogUrlToVideo from './FJBlogUrlToVideo';
import { useSelector } from 'react-redux';

const FJBlogUrlToVideoContainer = () => {
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);
    useLocalStore();

    return <FJBlogUrlToVideo textToVideoStep={textToVideoStep} />;
};

export default FJBlogUrlToVideoContainer;
